<template>
  <context-menu
    v-if="rightClickMenu.isVisible"
    :x="rightClickMenu.x"
    :y="rightClickMenu.y"
    @close="rightClickMenu.hide"
  >
    <button
      v-for="action in rightClickMenu.actions"
      :key="action.title"
      type="button"
      class="context-menu__entry"
      :class="action.class ? [action.class] : []"
      @click="doAction(action)"
    >
      {{ action.title }}
    </button>
  </context-menu>
</template>

<script setup lang="ts">
import { useRightClickMenu } from "@core/ui/rightClickMenu.store";
import ContextMenu from "./ContextMenu.vue";

const rightClickMenu = useRightClickMenu();

function doAction(action: {
  callback: (event: { x: number; y: number }) => void;
}) {
  action.callback({ x: rightClickMenu.x, y: rightClickMenu.y });
  rightClickMenu.hide();
}
</script>

<style></style>
